@if (heading && heading.length) {
<h3>{{ heading }}</h3>
}
<ng-container [formGroup]="formGroup">
  <div class="chip-listbox-wrapper">
    <mat-chip-listbox #chiplistbox [multiple]="true" class="chip-listbox">
      @for (item of items; track item) { @if (!selectedItems.length ||
      isSelected(item) || show(item)) {
      <mat-chip-option
        [matBadge]="item.badge"
        [ngClass]="{
          itemClass: itemClassDefault,
          big: item.fault === undefined,
          'big-nok': item?.fault,
          'big-ok': item.fault !== undefined && !item?.fault,
          'big-highligt': item.glow
        }"
        [selected]="isSelected(item)"
        (click)="onClick(item)"
        (keydown)="onKeyPress($event, item)"
        color="custom"
      >
        {{ item.displayname }}
      </mat-chip-option>
      } }
    </mat-chip-listbox>
  </div>
  <div>
    @if (enableInput && !this.selectedItems.length) {
    <input
      class="medium"
      matInput
      [placeholder]="inputHeading"
      type="number"
      [attr.inputmode]="inputModeType"
      autocomplete="off"
      formControlName="newvalue"
      (focusout)="onFocusout()"
      (keyup)="onKeyUp($event)"
      (keydown)="onKeyDown($event)"
    />
    }
  </div>
</ng-container>
